<template>
  <v-tabs class="date-time-picker" v-model="activeTab" fixed-tabs>
    <v-tab key="calendar">
      <v-icon>event</v-icon>
    </v-tab>
    <v-tab key="sundial">
      <v-icon>access_time</v-icon>
    </v-tab>
    <v-tab-item key="calendar">
      <v-date-picker :value="date" v-bind="datePickerProps" @input="dateInput" full-width></v-date-picker>
    </v-tab-item>
    <v-tab-item key="sundial">
      <v-time-picker
        ref="timePicker"
        :value="time"
        v-bind="timePickerProps"
        @input="timeInput"
        @change="timeChange"
        full-width
      ></v-time-picker>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  name: 'DateTimePicker',
  props: {
    value: {
      type: String,
      description:
        'ISO date time already converted to the right time zone for display. Specific format expected is yyyy-MM-ddTHH:mm.'
    },
    datePickerProps: {
      type: Object
    },
    timePickerProps: {
      type: Object
    }
  },
  data() {
    return {
      activeTab: 0,
      date: '',
      time: ''
    }
  },
  watch: {
    value() {
      this.initializeDateTime()
    }
  },
  methods: {
    initializeDateTime() {
      if (!this.value) {
        this.date = ''
        this.time = ''
        return
      }
      let parts = this.value.split('T')
      this.date = parts && parts.length ? parts[0] : ''
      this.time = parts && parts.length > 1 ? parts[1] : ''
    },
    dateInput(newDate) {
      this.date = newDate
      let dateTimeString = this.assembleDateTime(newDate, this.time)
      if (dateTimeString) {
        this.$emit('input', dateTimeString)
      }
      this.showTimePicker()
    },
    timeInput(newTime) {
      this.time = newTime
      let dateTimeString = this.assembleDateTime(this.date, newTime)
      if (dateTimeString) {
        this.$emit('input', dateTimeString)
      }
    },
    timeChange(newTime) {
      let dateTimeString = this.assembleDateTime(this.date, newTime)
      if (dateTimeString) {
        this.$emit('change', dateTimeString)
      }
    },
    assembleDateTime(date, time) {
      if (date && time) {
        return date + 'T' + time
      } else {
        return null
      }
    },
    showTimePicker() {
      this.activeTab = 1
    }
  },
  mounted() {
    this.initializeDateTime()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-picker--date .v-picker__title {
  min-height: 102px; //  Makes the header height for date picker the same as that of the time picker
}
</style>
